import { useMutation } from "@tanstack/react-query";
import api from "apis";

const useUserDeleteMutation = () => {
  return useMutation({
    mutationFn: api.user.deactivateUser,
  });
};

export default useUserDeleteMutation;
